import React, { Component } from 'react';
import { PQR } from './PQR/Pqr';

export class Home extends Component {
    static displayName = Home.name;

    componentDidMount() {
        window['afterRender']();
    }

    render() {
        require("./home.css");
        return (

            <div>

                <div className="wrapp-banner">

                    <div className="logo-banner">
                        <h2>Atrevete a vivir</h2>
                        <h3>Una vida diferente</h3>
                        <img src={require('../images/logo.png')} />
                    </div>
                    <div className="back"></div>
                    <div className="rotator">
                        <img src={require('../images/banner.jpg')} />
                    </div>
                </div>

                <div className="row service col-md-10">
                    <div className="col-md-12">
                        <h2 className="text-center d-inline-block">Entrenamientos</h2>
                    </div>


                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 mt-3">

                        <div class="card" >
                            <img src={require('../images/hand.png')} className="mt-3" />
                                <div class="card-body">
                                    <h5 class="card-title">Entrenamiento básico</h5>
                                <p class="card-text">Descubre tus barreras limitantes.</p>
                                <a href="/proceso-basico" class="btn btn-primary">Conocer más</a>
                                </div>
                        </div>
                       
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 mt-3">

                        <div class="card">
                            <img src={require('../images/fly.png')} className="mt-3" />
                            <div class="card-body">
                                <h5 class="card-title">Entrenamiento avanzado</h5>
                                <p class="card-text">Rompe barreras limitantes y llevate al límite.</p>
                                <a href="/proceso-avanzado" class="btn btn-primary">Conocer más</a>
                            </div>
                        </div>

                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 mt-3">

                        <div class="card" >
                            <img src={require('../images/cine.png')} className="mt-3" />
                            <div class="card-body">
                                <h5 class="card-title">Programa de liderazgo</h5>
                                <p class="card-text">Resultados garantizados en tu vida, logros extraordinarios <b>Ahora!</b></p>
                                <a href="/proceso-pl" class="btn btn-primary">Conocer más</a>
                            </div>
                        </div>

                    </div>

                    <div className="col-md-10 mt-5">
                        Nuestros entrenamientos se basan en la tecnolog&iacute;a de la transformaci&oacute;n humana, en el cual nos permite ofertar ejercicios, din&aacute;micas, distinciones y herramientas, que se apoyan en la vida de cualquier ser humano, llev&aacute;ndolos y ganando en sus relaciones familiares, de pareja, laborales y en cada una. Las &aacute;reas de su vida, convirti&eacute;ndose en L&Iacute;DERES DE SU PROPIA VIDA con resultados y herramientas para despertar la conciencia y crear valor en el desarrollo personal e inteligencia emocional.
                    </div>
                </div>

                <div className="row mt-5">
                    <h2 className="text-center d-inline-block">SOMOS</h2>
                    <p className="parrafo-1 text-center margin-bottom">Un equipo de lideres listos para llevarte a ganar</p>
                </div>

                <div className="row team slider">
                    <div class="item col-md-12">
                        <img src={require('../images/Alejandro.jpg')} />
                    </div>
                    <div class="item col-md-12">
                        <img src={require('../images/Laura.jpg')} />
                    </div>
                    <div class="item col-md-12">
                        <img src={require('../images/Andrea.jpg')} />
                    </div>
                    <div class="item col-md-12">
                        <img src={require('../images/ivan.jpg')} />
                    </div>
                    <div class="item col-md-12">
                        <img src={require('../images/Pedro.jpg')} />
                    </div>
                </div>

                <div className="slide-rows mt-3 mb-5">
                    <input type="button" className="b-pp2" value="<" title="Anterior"></input>
                    <input type="button" className="b-nn2" value=">" title="Anterior"></input>
                </div>

                <div className="wrapp-about">
                    <div className="row about mt-5">

                        <h2 className="text-center d-inline-block">NOSOTROS</h2>

                        <p>
                            Somos una organizaci&oacute;n dedicada a ofrecer SERVICIOS, TECNOLOG&Iacute;A Y APOYO para seres humanos interesados en llevar los resultados de su vida a otro nivel. Creemos en seres humanos capaces de tenerlo todo y que los resultados actuales tienen que ver con lo que creemos que podemos tener. Es por eso que creamos un contexto SEGURO, donde ofrecemos HERRAMIENTAS por medio de ENTRENAMIENTOS VIVENCIALES para apoyar a los seres humanos a desarrollar todo su potencial y llevar los resultados de su vida a niveles inimaginables para ellos.
                        </p>
                        <p>
                            Nuestros entrenamientos est&aacuten basados en tecnolog&iacute;a de TRANSFORMACI&Oacute;N HUMANA, la cual nos permite ofertar ejercicios, din&aacute;micas, distinciones y herramientas, que apoyan en la vida de cualquier ser humano, llev&aacute;ndolos a ganar en sus relaciones familiares, de pareja, laborales y en cada una de las &aacute;reas de su vida, convirti&eacute;ndolos en L&Iacute;DERES DE SU PROPIA VIDA con resultados y herramientas para despertar conciencia y crear valor al desarrollo personal e inteligencia emocional.



                            LIFE est&aacute; conformado por seres humanos entrenados en Liderazgo, que est&aacute;n comprometidos con una visi&oacute;n en com&uacute;n, vivir en un mundo donde valga la pena vivir y podamos compartir la grandeza humana. Un mundo con resultados para todos, un mundo de transformaci&oacute;n y desarrollo humano.



                            Equipo de LIFE -C.E.L-
                        </p>

                    </div>
                </div>



                <div class="mapouter row p-3">
                    <div class="col-md-6">
                        <PQR />
                    </div>
                    <div class="gmap_canvas col-md-6">
                        <iframe width="100%" height="100%" id="gmap_canvas" src="https://maps.google.com/maps?q=life%20centro%20de%20entrenamiento&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                    </div>
                </div>
            </div>
        );
    }
}
